import styled, { css } from 'styled-components';

import { mediaMixin, StyledTableCell, Table, token } from '@zillow/constellation';

export const StyledTable = styled(Table)`
  ${mediaMixin(
    'md_lte',
    css`
      ${StyledTableCell} {
        padding: 12px 0px;
      }
    `,
  )}
`;

export const StyledHighlightedTableCell = styled(Table.Cell)`
  &&& {
    background-color: ${token('colors.backgroundBlue')};
    vertical-align: middle;
  }
`;

export const StyledCenteredTableCell = styled(Table.Cell)`
  &&& {
    vertical-align: middle;
  }
`;

export const StyledHighlightedTableHeaderCell = styled(Table.HeaderCell)`
  &&& {
    background-color: ${token('colors.backgroundBlue')};
  }
`;
